export class ItemGridData {
  id=0;
  item = "";
  description = "";
  shiptoDate: Date | null = null ;
  checked = false;
}
